import { Spinner } from '@/components/ui/spinner'

export const MapLoading = () => {
	return (
		<div className='flex h-full w-full items-center justify-center rounded-lg bg-neutral-50'>
			<div className='flex flex-col items-center gap-4'>
				<Spinner className='fill-neutral-500' size={32} />
				<p className='m-0 text-neutral-600 text-sm'>
					Loading neighborhoods...
				</p>
			</div>
		</div>
	)
}
